function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiminiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 557.163,
    height: 680.16,
    viewBox: "0 0 147.416 179.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fillOpacity: 1,
      stroke: "red",
      strokeWidth: 1.81089795,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0,
      paintOrder: "markers fill stroke"
    },
    d: "M72.416 117.946A11.554 11.554 0 0 0 60.862 129.5a11.554 11.554 0 0 0 11.554 11.553A11.554 11.554 0 0 0 83.969 129.5a11.554 11.554 0 0 0-11.553-11.554zm0 29.96a74.095 74.095 0 0 0-71.51 54.79H16.67a59.059 59.059 0 0 1 48.245-39.242v117.058a59.059 59.059 0 0 1-48.241-39.208H.968a74.095 74.095 0 0 0 71.448 54.79A74.095 74.095 0 0 0 146.51 222a74.095 74.095 0 0 0-74.094-74.094Zm7.5 15.573a59.059 59.059 0 0 1 51.558 58.52 59.059 59.059 0 0 1-51.558 58.508z",
    transform: "translate(0 -117.041)",
    fill: "current"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiminiLogo);
export default __webpack_public_path__ + "static/media/dimini-logo.81e5d0dd3073e9568e3dd272b1ee080c.svg";
export { ForwardRef as ReactComponent };